import { render, staticRenderFns } from "./blog-5.vue?vue&type=template&id=190d77a2&scoped=true"
import script from "./blog-5.vue?vue&type=script&lang=js"
export * from "./blog-5.vue?vue&type=script&lang=js"
import style0 from "./blog-5.vue?vue&type=style&index=0&id=190d77a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d77a2",
  null
  
)

export default component.exports